var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkMall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6C8.25 4.20161 9.75833 2.4352 11.6333 2.26735C13.8667 2.05954 15.75 3.74602 15.75 5.84814",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79558 9.23189C3.7706 8.28285 4.53313 7.5 5.48249 7.5H18.5175C19.4669 7.5 20.2294 8.28285 20.2044 9.23189L20.0191 16.273C19.9389 19.3209 17.445 21.75 14.3961 21.75H9.60392C6.55496 21.75 4.06108 19.3209 3.98087 16.273L3.79558 9.23189Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3707 14.5341C13.9311 14.1026 14.283 13.4134 14.2473 12.6428C14.1952 11.5085 13.2811 10.5779 12.1486 10.5048C10.8387 10.4207 9.75 11.4582 9.75 12.7498C9.75 13.4765 10.0946 14.1218 10.6284 14.5332C10.7007 14.5889 10.7985 14.5953 10.8771 14.5506C11.208 14.3595 11.591 14.2507 11.9996 14.2507C12.4082 14.2507 12.7921 14.3604 13.123 14.5506C13.2016 14.5953 13.2994 14.5889 13.3707 14.5341Z",
    fill: "#F7DE2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3716 14.7169C13.2994 14.6612 13.2016 14.6548 13.123 14.6995C12.7921 14.8906 12.4091 14.9994 12.0005 14.9994C11.5919 14.9994 11.208 14.8897 10.8771 14.6995C10.7984 14.6548 10.7006 14.6612 10.6293 14.716C10.0681 15.1475 9.71708 15.8376 9.75273 16.6073C9.80574 17.7417 10.7189 18.6731 11.8515 18.7453C13.1614 18.8294 14.2501 17.7919 14.2501 16.5003C14.2501 15.7736 13.9055 15.1283 13.3716 14.7169Z",
    fill: "#F7DE2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkMall);
export default __webpack_public_path__ + "static/media/icon_link_mall.cca90f4c03a063162f3d326638735df9.svg";
export { ForwardRef as ReactComponent };